import { useMemo } from "react";
import { Directions, Gesture } from "react-native-gesture-handler";
import { runOnJS } from "react-native-reanimated";

const useRecapGesture = ({
	contentAreaWidth,
	onSelectionChange: onSelectionChangeProp,
}: {
	contentAreaWidth: number;
	onSelectionChange?: (change: number) => void;
}) => {
	const gesture = useMemo(() => {
		const onSelectionChange = (change: number) => {
			onSelectionChangeProp?.(change);
		};
		return Gesture.Race(
			Gesture.Fling()
				.direction(Directions.RIGHT)
				.onEnd(() => {
					runOnJS(onSelectionChange)(-1);
				}),
			Gesture.Fling()
				.direction(Directions.LEFT)
				.onEnd(() => {
					runOnJS(onSelectionChange)(1);
				}),
			Gesture.Tap().onEnd((event) => {
				if (event.x > contentAreaWidth / 2) {
					runOnJS(onSelectionChange)(1);
				} else {
					runOnJS(onSelectionChange)(-1);
				}
			}),
		);
	}, [contentAreaWidth, onSelectionChangeProp]);

	return gesture;
};
export default useRecapGesture;
